
// 文本多行展开收起组件
Vue.component("search_by_picture_modal", {
  props: {
  },
  data() {
    return {
      visible: false,
      loading: false,
      filePath: '',
      pager: {
        page: 1,
        size: 30,
        total: 0,
      },
      ids: '',
      list: [],
      times: 0,//轮询次数
    };
  },
  mounted() {
  },
  methods: {
    open(path) {
      document.documentElement.style.overflow = 'hidden'
      this.visible = true
      this.search(path)
    },
    uploadSuccess(res, file) {
      if (res.status == 200) {
        let path = res.data.httpPath
        this.search(path)
      }
    },
    search(path) {
      this.loading = true
      this.filePath = path
      this.pager.page = 1
      this.pager.size = 30
      this.pager.total = 0
      this.list = []
      let filePath = path.indexOf('://') < 0? ('/mstorage' + path): path
      API.reqStartSearchPicture({ filePath }).then(res => {
        if (res.success && res.data.code == 0) {
          this.times = 0
          this.getPictureIds(res.data.data.guid)
        }
      })
    },
    getPictureIds(taskGuid) {
      const that = this
      if (that.times > 60) {
        return that.loading = false
      }
      that.times++
      API.reqSearchPicture({ taskGuid }).then(res => {
        if (res.success && res.data.code == 0 && res.data.data) {
          that.ids = res.data.data.peopleIds
          that.getList()
        } else if (res.success && (res.data.code == 1 || res.data.code == 2)) {
          //轮询
          setTimeout(() => {
            that.getPictureIds(taskGuid)
          }, 1000);
        } else {
          that.loading = false
        }
      }).finally(err => {
        that.loading = false
      })
    },
    getList() {
      this.loading = true
      API.reqSearchPictureList({ imagesIds: this.ids, page: this.pager.page, size: this.pager.size }).then(res => {
        if (res.status == 200) {
          this.pager.page = res.data.page
          this.pager.size = res.data.size
          this.pager.total = res.data.total
          this.list = res.data.results
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleClosed() {
      this.list = []
      this.filePath = ''
      document.documentElement.style.overflow = 'auto'
    },
    beforeUpload(file){
      if(file.type != 'image/jpeg' && file.type != 'image/png'){
        this.$message.warning(this.$t('暂不支持该格式图片检索，请重新上传'))
        return false
      }
    }
  },
  template: `
      <el-dialog :visible.sync="visible" class="search_by_picture_modal" :modal="false" @closed="handleClosed">
        <div class="pic_panel">
          <div class="header">
            <div class="back_btn" @click="visible = false">< 返回</div>
            <el-upload
              action="/learn/v1/upload/fileupload"
              :show-file-list="false"
              :on-success="uploadSuccess"
              accept="image/png, image/jpeg"
              :before-upload="beforeUpload">
              <div class="upload_btn"><iconfont style="font-size:16px;" type="iconshangchuan2"></iconfont>上传</div>
            </el-upload>
          </div>
          <div class="picture_box">
            <div class="picture" v-show="filePath">
              <div class="circle circle_1"></div>
              <div class="circle circle_2"></div>
              <div class="circle circle_3"></div>
              <div class="circle circle_4"></div>
              <img :src="filePath" alt="">
            </div>
          </div>
        </div>
        <div class="result_panel" v-loading="loading">
          <el-empty v-if="!loading && !list.length" description="糟糕，没有找到相似内容~"></el-empty>
          <div class="list">
            <a :href="'/rman/#/basic/rmanDetail/' + item.entityData.contentId_" target="_blank" class="item" v-for="item in list" :key="item.entityData.contentId_">
              <img class="cover" :src="item.entityData.keyframe_" alt=""/>
              <div class="text">{{item.entityData.name}}</div>
            </a>
          </div>
          <el-pagination 
            @size-change="getList" 
            @current-change="getList" 
            :current-page.sync="pager.page"
            :page-sizes="[30, 60, 90, 120]" :page-size.sync="pager.size"
            layout="total, prev, pager, next, sizes, jumper" 
            :total="pager.total"
            small>
          </el-pagination>
        </div>
      </el-dialog>
  `,
});